import { Alert } from 'antd';
import styled from 'styled-components';

const StyledAlert = styled(Alert)`
  border: 1px solid #ff0000;
  border-radius: 4px;
  padding: 10px;
  background-color: #fffdfd;

  & .title {
    color: #ff0000;
    font-weight: bold;
  }

  & a {
    color: #262626;
    font-weight: bold;
    text-decoration: underline;
  }
`;

export default StyledAlert;
